<template>
  <div class="animated fadeIn">
    <b-row v-if="packageId === undefined">
      <b-col sm="12">
        <el-table
          :size="'mini'"
          :header-row-class-name="headerFontSize"
          :data="getPackageList360"
          :default-sort="{prop: 'date_assigned'}"
          v-loading="loading"
        >
          <el-table-column sortable label="Package Name" sort-by="block_name">
            <template slot-scope="scope">
              <router-link :to="'/packages/v/' + scope.row.id">{{ scope.row.block_name }}</router-link>
            </template>
          </el-table-column>
          <el-table-column label="Instrument">
            <template slot-scope="scope">{{ displayTestName(scope.row.instrument) }}</template>
          </el-table-column>
          <el-table-column label="Test Codes">
            <el-table-column width="90" prop="user_count" label="Total" sortable></el-table-column>
            <el-table-column width="90" prop="used_count" label="Used"></el-table-column>
            <el-table-column width="93" prop="used_count" label="Available">
              <template
                slot-scope="scope"
              >{{ freeCodes(scope.row.user_count, scope.row.used_count) }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column sortable label="Date" sort-by="date_assigned" width="240">
            <template slot-scope="scope">
              <i class="el-icon-time"></i>
              <span style="margin-left: 10px">{{ formatDate(scope.row.date_assigned) }}</span>
            </template>
          </el-table-column>
          <el-table-column label width="140">
            <template slot-scope="scope">
              <el-button size="mini" @click="packageView(scope.$index, scope.row)">View</el-button>
              <el-tooltip class="item" effect="dark" :content="'Package Settings'" placement="top">
                <el-button size="mini" @click="packageSettings(scope.$index, scope.row)">
                  <i class="el-icon-setting"></i>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </b-col>
    </b-row>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { unserialize } from '../../../shared/unserialize.js';
import moment from 'moment';

export default {
  name: 'tables',
  computed: {
    ...mapGetters('packages', ['getPackageList360']),
    ...mapGetters('auth', ['getCompanyName']),
    ...mapGetters('tests', ['getTestNameById'])
  },
  data: () => {
    return {
      packageId: undefined,
      loading: true
    };
  },
  created() {
    if (this.$route.params.packageId) {
      this.packageId = parseInt(this.$route.params.packageId, 10);
    }
    const p = [];
    p.push(this.fetchTests());
    p.push(this.fetchPackageList360());
    Promise.all(p).then(() => {
      this.loading = false;
    });
  },
  watch: {
    $route() {
      if (this.$route.params.packageId) {
        this.packageId = parseInt(this.$route.params.packageId, 10);
      } else {
        this.packageId = undefined;
      }
    }
  },
  methods: {
    ...mapActions('packages', ['fetchPackageList360']),
    ...mapActions('tests', ['fetchTests']),
    packageView(index, i) {
      this.$router.push('/packages/v/' + i.id);
    },
    packageSettings(index, i) {
      this.$router.push('/packages/s/' + i.id);
    },
    freeCodes(s, e) {
      let ss = parseInt(s, 10);
      let ee = parseInt(e, 10);
      if (ss - ee < 0) {
        return 0;
      }
      return ss - ee;
    },
    relativeDate(input) {
      const a = moment();
      const b = moment(input);
      if (a.diff(b, 'years') > 1) {
        return moment(input).format('MMM Do YYYY');
      } else if (a.diff(b, 'years') === 1) {
        return moment(input).format('dddd, MMMM Do');
      } else {
        return moment(input, 'YYYYMMDD').fromNow();
      }
    },
    formatDate(input) {
      return moment(input).format('M/D/YYYY h:mm a z');
    },
    showRenameModal(index, name) {
      this.$prompt('Please type the new name', 'Renaming Package', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        inputPattern: /\w/,
        inputErrorMessage: 'Invalid Package Name'
      })
        .then(({ value }) => {
          // Vuex Call
          this.$message({
            type: 'success',
            message: 'Your email is:' + value
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Input canceled'
          });
        });
    },
    displayTestName(rawTestIds) {
      let names = [];
      let testIds = undefined;
      // Handle legacy test ids, (non-bundles)
      if (rawTestIds.toString() === parseInt(rawTestIds, 10).toString()) {
        testIds = rawTestIds;
      } else {
        testIds = unserialize(rawTestIds);
      }
      for (const inc in testIds) {
        let leTestId = parseInt(testIds[inc], 10);
        const testData = this.getTestNameById(leTestId);
        if (testData !== undefined) names.push(testData.abbreviated_name);
        else names.push('Unknown');
      }
      return names.join(', ');
    },
    headerFontSize() {
      return 'small-hdr-font';
    }
  }
};
</script>
<style lang="scss" scoped>
.small-hdr-font {
  font-size: 12px !important;
  .cell {
    font-size: 12px !important;
  }
}
</style>
